module.exports = __webpack_public_path__ + "static/img/help1.96d26665.jpg";